import { Route }      from 'react-router-dom';
import StandImport    from './views/StandImport';
import StandList      from './views/StandList';
import StandDashboard from './views/StandDashboard';

export default [
  <Route element={<StandList />} key="list" path="/salons/:showId/stands" />,
  <Route element={<StandImport />} key="import" path="/salons/:showId/stands/importation" />,
  <Route element={<StandDashboard />} key="show" path="/stands/:id" />,
];
